import isProduction from '@/utils/isProduction';

export const pianoId = isProduction() ? '630384' : '630385';
